import { INSIGHT_CUBE_NAME } from '@/api/hcp/interaction/types';
import { INSIGHT_DATE_DIMENSION } from '@/pages/Insights/constants';
import { FilterConfigDynamic } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { FilterLimitPresets } from '../../filterDefaultLimits';
import { isNonEmptyStringArray } from '../../utils';
import mapDimensionToOption from '../../utils/mapDimensionToOption';

const DIMENSION = `${INSIGHT_CUBE_NAME}.employee_type`;

const insightEmployeeTypeFilter: FilterConfigDynamic = {
  label: 'main.insights.filters.labels.employeeType',
  placeholder: 'main.insights.filters.labels.employeeType',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  useFloatingLabel: true,
  sourceCube: INSIGHT_CUBE_NAME,
  getOptionsQuery: ({ dateRange }) => ({
    dimensions: [DIMENSION],
    limit: FilterLimitPresets.LIMIT_100,
    timeDimensions: [getDateRangeTimeDimension({ dateRange, dimension: INSIGHT_DATE_DIMENSION })],
  }),
  mapResult: mapDimensionToOption(DIMENSION),
  applyFilter: value => {
    if (!isNonEmptyStringArray(value)) return undefined;

    return {
      member: DIMENSION,
      operator: 'equals',
      values: value,
    };
  },
};

export default insightEmployeeTypeFilter;
